import { render } from "./AsideDetail.vue?vue&type=template&id=41e24c49"
import script from "./AsideDetail.vue?vue&type=script&lang=js"
export * from "./AsideDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__